module.exports = __webpack_public_path__ + "img/2.3.9214d80a.png";